import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

const daysOrder = [
  'monday', 'tuesday', 'wednesday',
  'thursday', 'friday', 'saturday', 'sunday',
];

const formatTime12Hour = (time) => {
  if (!time) return '';
  const [hour, minute] = time.split(':');
  let h = parseInt(hour, 10);
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${minute} ${ampm}`;
};

const StoreHoursModal = ({ show, onClose, storeHours, isOpen }) => {
  const renderStoreHours = () => {
    if (!storeHours) return <p className="text-muted">Store hours not available</p>;
    if (typeof storeHours === 'string')
      return <p className="location-modal__name mb-2">{storeHours}</p>;

    if (typeof storeHours === 'object') {
      return (
        <div className="store-hours-list">
          {daysOrder.map((day) => {
            const dayData = storeHours[day];
            const isEnabled = dayData?.enabled;
            const openTime = dayData?.open;
            const closeTime = dayData?.close;

            return (
              <div
                key={day}
                className="d-flex border-bottom justify-content-between mb-4 store-hours-row"
              >
                <span className="h3 fw-bold text-capitalize">{day}</span>
                <span style={{ display: "flex", gap: "5px", maxWidth: "175px", width: "100%" }}>
                  {isEnabled && openTime && closeTime ? (
                    <>
                      <span style={{ flex: "1" }} className="badge font-weight-bold mx-0 mb-2 shadow-none h2 py-2 alert-info px-3 badge-pill">
                        {formatTime12Hour(openTime)}
                      </span>
                      <span>
                        {" - "}
                      </span>
                      <span style={{ flex: "1" }} className="badge font-weight-bold mx-0 mb-2 shadow-none h2 py-2 alert-info px-3 badge-pill">
                        {formatTime12Hour(closeTime)}
                      </span>
                    </>
                  ) : (
                    <span
                      style={{ maxWidth: "175x", textAlign: "center" }}
                      className="badge font-weight-bold mx-0 mb-2 w-100 shadow-none  h2 py-2 alert-info badge-pill px-3"
                    >
                      Closed
                    </span>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  return (
    <Modal show={show} onHide={onClose} dialogClassName="location-modal">
      <button className="close" type="button" aria-label="Close" onClick={onClose} />
      <div className="p-sm-5 py-5 px-4">
        <h2 className="mb-4"> Store Hours</h2>
        {typeof isOpen === 'boolean' && (
          <p className={`store-status mb-3 ${isOpen ? 'open' : 'closed'}`}>
            Currently {isOpen ? 'Open' : 'Closed'}
          </p>
        )}
        {renderStoreHours()}
      </div>
    </Modal>
  );
};

StoreHoursModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  storeHours: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(
      PropTypes.shape({
        open: PropTypes.string,
        close: PropTypes.string,
        enabled: PropTypes.bool,
      })
    ),
  ]),
  isOpen: PropTypes.bool,
};

StoreHoursModal.defaultProps = {
  onClose: () => { },
  show: false,
  storeHours: '',
  isOpen: undefined,
};

export default StoreHoursModal;
